import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId')({
  // Geofences now live under a geoset (`/geofences/:geosetId/:geofenceId`), and
  // this legacy link carries no geoset id to rebuild that path — send it to the
  // geosets index instead.
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/geosets',
      params: { workspaceId: params.workspaceId },
      replace: true,
    });
  },
});
